import React, { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useDispatch } from 'react-redux'
import {
  Box,
  Hidden,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  makeStyles,
  SvgIcon
} from '@material-ui/core'
import {
  Slash as SlashIcon,
  Menu as MenuIcon,
  MoreVertical as MoreIcon
} from 'react-feather'
import { openSidebar, pauseConversation } from 'src/actions/chatActions'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    height: 64,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  onlineIndicator: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginLeft: theme.spacing(2),
    flexGrow: 1
  }
}))

function Toolbar({ className, ...rest }) {
  const classes = useStyles()
  const { botId } = useParams()
  const moreRef = useRef(null)
  const dispatch = useDispatch()
  const [openMenu, setOpenMenu] = useState(false)
  const contact = undefined

  const handleOpenSidebar = () => {
    dispatch(openSidebar())
  }

  const handleMenuOpen = () => {
    setOpenMenu(true)
  }

  const handleMenuClose = () => {
    setOpenMenu(false)
  }

  const handleTogglePaused = contactId => {
    dispatch(pauseConversation(contactId, botId))
  }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <IconButton className={classes.menuButton} onClick={handleOpenSidebar}>
        <SvgIcon style={{ color: 'black' }} fontSize='small'>
          <MenuIcon />
        </SvgIcon>
      </IconButton>

      <Box flexGrow={1} />

      {/* <Tooltip title='More options'>
        <IconButton color='inherit' onClick={handleMenuOpen} ref={moreRef}>
          <SvgIcon fontSize='small'>
            <MoreIcon />
          </SvgIcon>
        </IconButton>
      </Tooltip> */}
      <Menu
        anchorEl={moreRef.current}
        keepMounted
        elevation={1}
        onClose={handleMenuClose}
        open={openMenu}
      >
        <MenuItem>
          <ListItemIcon>
            <SvgIcon color='inherit' fontSize='small'>
              <SlashIcon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText primary='Block contact' />
        </MenuItem>
      </Menu>
    </div>
  )
}

Toolbar.propTypes = {
  className: PropTypes.string
}

export default Toolbar
